import type { CommonHeroIconProps } from "./common-hero-icon-props.types"

export function OutlineChevronRightIcon({
  className,
  strokeWidth = 3,
}: CommonHeroIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
